/**
 * @generated SignedSource<<9be6d6ba93386ebae8e760de731eade7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type RewardKind = "Certificate" | "Email" | "MakeFachberater" | "PacPoints" | "PharmaPoints" | "Points" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type RewardForm_RewardConfigurationV2Fragment$data = {
  readonly id: string;
  readonly kind: RewardKind;
  readonly " $fragmentSpreads": FragmentRefs<"CertificatesRewardConfigurationForm_CertificateRewardConfigurationV2Fragment" | "EditAwardPacPointsConfigurationForm_AwardPacPointsFragment" | "EditAwardPharmaPointsConfigurationForm_AwardPharmaPointsFragment" | "EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment" | "EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment">;
  readonly " $fragmentType": "RewardForm_RewardConfigurationV2Fragment";
};
export type RewardForm_RewardConfigurationV2Fragment$key = {
  readonly " $data"?: RewardForm_RewardConfigurationV2Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RewardForm_RewardConfigurationV2Fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RewardForm_RewardConfigurationV2Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmailRewardConfigurationForm_EmailRewardConfigurationV2Fragment"
        }
      ],
      "type": "EmailRewardConfiguration",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditAwardPacPointsConfigurationForm_AwardPacPointsFragment"
        }
      ],
      "type": "AwardPacPointsRewardConfiguration",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditAwardPharmaPointsConfigurationForm_AwardPharmaPointsFragment"
        }
      ],
      "type": "AwardPharmaPointsRewardConfiguration",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "CertificatesRewardConfigurationForm_CertificateRewardConfigurationV2Fragment"
        }
      ],
      "type": "CertificateRewardConfiguration",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EditFachberaterRewardConfigurationForm_MakeFachberaterRewardConfigurationFragment"
        }
      ],
      "type": "MakeFachberaterRewardConfiguration",
      "abstractKey": null
    }
  ],
  "type": "Reward",
  "abstractKey": "__isReward"
};

(node as any).hash = "071332216727f3c7a780d7f2014e692b";

export default node;
